const memoryCache = new Map();
const inflight = new Map();

const warmBrowserCache = url =>
  new Promise(resolve => {
    const img = new Image();
    img.decoding = "async";
    img.onload = () => resolve(url);
    img.onerror = () => resolve(url);
    img.src = url;
  });

export const getCachedImageUrl = async url => {
  if (memoryCache.has(url)) return memoryCache.get(url);

  if (inflight.has(url)) return inflight.get(url);

  const pending = warmBrowserCache(url).then(cachedUrl => {
    memoryCache.set(url, cachedUrl);
    inflight.delete(url);
    return cachedUrl;
  });

  inflight.set(url, pending);
  return pending;
};

export const preloadImages = urls => Promise.all(urls.map(getCachedImageUrl));
